import { render, staticRenderFns } from "./ConfigureList.vue?vue&type=template&id=1ca563c2&scoped=true&"
import script from "./ConfigureList.vue?vue&type=script&lang=js&"
export * from "./ConfigureList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureList.vue?vue&type=style&index=0&id=1ca563c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca563c2",
  null
  
)

export default component.exports